<template>
  <div class="k-onboarding__quest-wrapper">
    <div class="k-onboarding__quest">
      <div class="k-onboarding__quest-task">Выберите ваш уровень активности:</div>
      <div
        :class="['k-onboarding-button k-activity-button c-pointer', {'ob-orange': activity === activity_key, 'ob-white': activity !== activity_key}]"
        @click="setActivity(activity_key)"
        :key="activity_key"
        :data-key="activity_key"
        v-for="(activity_name, activity_key) in getActivityTypes"
      >{{ activity_name }}</div>
      <a
        href="#"
        @click.prevent="processSubmit"
        :class="['k-onboarding__quest-next', { active: validActivity }]"
      >Далее</a>
      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: "OnboardingActivity",
  props: {
    editProfile: Object,
  },
  computed: {
    ...mapGetters([
      'getActivityTypes',
    ]),
    activity: {
      get() {
        if (this.editProfile) return this.editProfile.activity;
        return this.$store.getters.getProfileActivity;
      },
      set(value) {
         if (!this.editProfile) {
          this.$store.dispatch("setProfileData", { activity: value });
        } else {
          this.editProfile.activity = value;
        }
      }
    },
    validActivity() {
      return this.activity;
    },
    currentCreatedProfile() {
      return this.$store.getters.getUserFamily.find(el => el.is_main === 't')
    }
  },
  methods: {
    ...mapActions([
      'updateProfile',
    ]),
    setActivity(activity) {
      this.activity = activity;
    },
    async processSubmit() {
      if (this.validActivity) {
        console.log('wtf', this.currentCreatedProfile && !this.editProfile)
        if (this.currentCreatedProfile && !this.editProfile) {
          await this.updateProfile({
            id: this.currentCreatedProfile.id,
            activity: this.activity,
          })
        }
        this.$router.push({ name: "OnboardingGoals" });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.k-activity-button {
  padding: 15px 25px;
  width: 80%;
}

@media (max-width: 850px) {
  .k-activity-button {
    width: 100%;
  }
}
</style>
